'use strict';

import angular from 'angular';
import { Enum } from '../../enum/index';

export class ConfirmPopupController {
  /*@ngInject*/
  constructor($mdDialog, title, message, yesText, noText) {
    let vm = this;
    vm.$mdDialog = $mdDialog;
    vm.title = (title ? title : 'APPLICATION.ALERT');
    vm.message = message;
    vm.yesText = (yesText ? yesText : 'APPLICATION.YES');
    vm.noText = (noText ? noText : 'APPLICATION.NO');
  };

  ok() {
    this.$mdDialog.hide();
  };
  cancel() {
    this.$mdDialog.cancel();
  };
}

export default angular.module('ngOskCrmApp.popup.confirmPopup', [])
  .controller('confirmPopupController', ConfirmPopupController)
  .name;


// WEBPACK FOOTER //
// ./client/app/shared/popup/confirm-popup/confirm-popup.controller.js